import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import assetSagas from './asset/sagas';
export default function* rootSaga(getState) {
	yield all([authSagas(), assetSagas()]);
}
